import React from "react";
import Overlay from "@components/Overlay";
import { useGlobalContext } from "@contexts/Global";

export const OverlayContainer = () => {
  const { showOverlay } = useGlobalContext();
  return <Overlay show={showOverlay} />;
};
